export * from "ce/api/OrganizationApi";
import type { ApiResponse } from "api/ApiResponses";
import type { AxiosPromise } from "axios";
import { OrganizationApi as CE_OrganizationApi } from "ce/api/OrganizationApi";

export class OrganizationApi extends CE_OrganizationApi {
  static async refreshLicense(): Promise<AxiosPromise<ApiResponse>> {
    return OrganizationApi.put("v1/tenants/license", {
      refreshExistingLicenseAndFlags: true,
    });
  }
  static async validateLicense(
    licenseKey: string,
  ): Promise<AxiosPromise<ApiResponse>> {
    return OrganizationApi.put("v1/tenants/license", { key: licenseKey });
  }
  static async validateLicenseForOnboarding(
    licenseKey: string,
  ): Promise<AxiosPromise<ApiResponse>> {
    return OrganizationApi.post("v1/tenants/license", { key: licenseKey });
  }
  static async removeLicense(): Promise<AxiosPromise<ApiResponse>> {
    return OrganizationApi.delete("v1/tenants/license");
  }
  static async validateLicenseDryRun(
    licenseKey: string,
  ): Promise<AxiosPromise<ApiResponse>> {
    return OrganizationApi.put("v1/tenants/license", {
      key: licenseKey,
      isDryRun: true,
    });
  }
}

export default OrganizationApi;
